import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { requiredWhenPresent } from '../../shared/propTypes';
import Modal from '../../shared/modals/modal.component';

import { messagePropTypes } from './propTypes';

const DeleteCommunicationModal = ({
  entityToRemove,
  hideModal,
  removeEntity,
  rowIndex,
  isVisible,
}) => {
  const removeObligation = useCallback(() => {
    removeEntity(entityToRemove, { rowIndex });
  }, [removeEntity, entityToRemove, rowIndex]);

  return (
    <Modal
      className="delete-obligations-modal"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete Communication"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={removeObligation}
      isVisible={isVisible}
    >
      {
        entityToRemove
          ? (
            <div>
              Are you sure you want to delete: <br/>
              {entityToRemove.title} <br/>
            </div>
          )
          : null
      }
    </Modal>
  );
};

DeleteCommunicationModal.propTypes = {
  entityToRemove: requiredWhenPresent(['isVisible'], messagePropTypes),
  hideModal: PropTypes.func.isRequired,
  removeEntity: PropTypes.func.isRequired,
  rowIndex: requiredWhenPresent(['isVisible'], PropTypes.number),
  isVisible: PropTypes.bool,
};

export default DeleteCommunicationModal;
